export default __webpack_public_path__ + "static/media/google-share-1-en.34ab716d.jpeg";